import { Spinner } from "@/icons";
import {
  AggregationItemCard,
  ArrowLink,
  Row,
  SectionHeading,
} from "../../components";
import "./CommunicationContentsHome.scss";

export type CommunicationContentsHomeProps = {
  sectionId?: string;
  title: string;
  elements: any[];
  loading?: boolean;
  noResultsLabel?: string;
  linkHref?: string;
  linkLabel?: string;
  asLink?: React.ElementType;
};

export function CommunicationContentsHome({
  sectionId,
  title,
  elements = [],
  loading = false,
  noResultsLabel = "Nessun risultato trovato",
  linkHref,
  linkLabel = "Scopri tutti",
  asLink = "a",
}: CommunicationContentsHomeProps) {
  const titleId = sectionId ? `${sectionId}-title` : undefined;

  return (
    <section
      id={sectionId}
      aria-labelledby={titleId}
      className="communication-contents d-flex section-gap flex-column"
    >
      <SectionHeading
        className="title pb-x16"
        title={title}
        titleId={titleId}
        color="slate-20"
        mdFs="2"
        titleMarginBottom="mb-x0"
        descriptionMarginBottom="mb-x0"
      >
        {linkHref && (
          <ArrowLink href={linkHref} asLink={asLink} fs="7">
            {linkLabel.toUpperCase()}
          </ArrowLink>
        )}
      </SectionHeading>
      <div className="masonry-component">
        {elements?.map((element) => (
          <AggregationItemCard {...element} key={element._id} />
        ))}
      </div>
      <Row className="w-full-adpt" justifyContent="center" m="x12">
        {loading && (
          <div
            role="status"
            aria-live="polite"
            aria-label="Caricamento in corso"
          >
            <Spinner height={30} width={30} />
          </div>
        )}
      </Row>
      <p className="total-elements-label">
        {elements?.length === 0 && <span>{noResultsLabel}</span>}
      </p>
    </section>
  );
}
